import React from 'react';
import classNames from 'classnames';

const FooterNav = ({
                       className,
                       ...props
                   }) => {

    const classes = classNames(
        'footer-nav',
        className
    );

    return (
        <div
            {...props}
            className={classes}
        >
            <p className="m-0">〒111-0055 東京都台東区三筋1-4-16 康江ビル</p>
            <p className="m-0">電話：03-5825-6261</p>
            <p className="m-0">FAX：03-5825-6252</p>
            <p className="m-0">HP:<a href='https://syurou-hope.com'>https://syurou-hope.com/</a></p>
            <p className="m-0">営業時間：平日9:00～18:00</p>
        </div>
    );
}

export default FooterNav;